import { useMemo, useRef } from "react";
// import Highcharts from "highcharts";
// import { Chart } from "@highcharts/react";
import HighchartsReact, { HighchartsReactRefObject } from "@highcharts/react";
import {
  Chart,
  Series,
  Title,
  XAxis,
  YAxis,
  Highcharts,
  HighchartsOptionsType,
} from "@highcharts/react";
import exporting from "highcharts/modules/exporting";
import exportData from "highcharts/modules/export-data";
import offlineExporting from "highcharts/modules/offline-exporting";
import { barChartData, BarChartDataPoint } from "../mockData";
// import "../style.css";
import {
  SeriesOptionsType,
  XAxisOptions,
  YAxisOptions,
} from "highcharts/highcharts.src";
import { XAxisProps } from "@highcharts/react/options/XAxis";
import { YAxisProps } from "@highcharts/react/options/YAxis";
import { SeriesProps } from "@highcharts/react/Highcharts";
import { format } from "date-fns-jalali";
import { TSeries, TXAxis, TYAxis } from "components/Charts/BarChart/type";

// if (typeof Highcharts === "object") {
//   if (
//     typeof window !== "undefined" &&
//     (window as any).Highcharts?.modules?.exporting
//   ) {
//   } else {
//     exporting(Highcharts);
//     offlineExporting(Highcharts);
//     exportData(Highcharts);
//   }
// }

type TProps = {
  title?: string;
  // series: SeriesProps[];
  // xAxis: XAxisProps;
  // yAxis: YAxisProps;
  series: TSeries[];
  xAxis: TXAxis;
  yAxis: TYAxis;
  data?: BarChartDataPoint[];
};

export function BarChart(props: TProps) {
  const { data = barChartData, title, series, yAxis, xAxis } = props;
  const chartRef = useRef<HighchartsReactRefObject>(null);
  const chartOptions: HighchartsOptionsType = {
    legend: {
      enabled: true,
      y: 8,
      squareSymbol: false,
      borderRadius: 64,
      symbolHeight: 12,
      symbolWidth: 12,
      rtl: true,
    },
    scrollbar: {
      enabled: true,
      buttonsEnabled: false,
      trackBorderRadius: 0,
      margin: 0,
      trackBorderColor: "#CDD4DC", // gray-30
      height: 0.1,
    },
    rangeSelector: {
      inputEnabled: false,
      allButtonsEnabled: false,
      buttons: [],
      labelStyle: {
        fontSize: "9px",
      },
    },
    lang: {
      rangeSelectorZoom: "Granularity",
    },
    plotOptions: {
      series: {
        legendSymbol: "rectangle",
        zones: [
          {
            fillColor: "transparent",
          },
        ],
        dataGrouping: {
          enabled: false, // Disable data grouping
        },
      },
    },
    // navigator: {
    //   outlineWidth: 1,
    //   outlineColor: "#F0F2F5",
    //   series: series,
    //   maskFill: "rgba(201, 207, 214, 0.3)",
    //   xAxis: {
    //     plotBands: [
    //       {
    //         from: -100,
    //         to: 10000,
    //         color: "rgba(16, 16, 16, 0.5)",
    //       },
    //     ],
    //     type: "datetime",
    //     labels: {
    //       formatter: function () {
    //         return format(new Date(this.value), "yyyy");
    //       },
    //       style: {
    //         fontSize: "9px",
    //       },
    //       y: 12,
    //     },
    //   },
    // },
    yAxis: {
      title: {
        text: yAxis.title?.text || "",
      },
    },
    xAxis: {
      type: "datetime",
      ordinal: false, // Prevent grouping into larger intervals
      labels: {
        formatter: function () {
          return format(new Date(this.value), "dd MMMM") || "";
        },
        style: {
          fontSize: "9px",
        },
      },
      categories: xAxis.categories,
    },
    // series: [{ data: series[0].data, xAxis: xAxis }],
    // tooltip: {
    //   shared: true,
    //   dateTimeLabelFormats: {
    //     day: "%A, %b %e, %Y",
    //   },
    // },
    tooltip: {
      formatter: function () {
        const date = format(this.category, "yyyy/MM/dd");
        let s = `<b>${date}</b><br/>`;
        this.points?.forEach((point) => {
          s += `<span style="color:${point.color}">\u25CF</span> ${point.series.name}: <b>${point.y}</b><br/>`;
        });
        return s;
      },
      shared: true,
    },
    // tooltip: {
    //   useHTML: true,
    //   padding: 0,
    //   borderColor: "transparent",
    //   backgroundColor: "transparent",
    //   ...(TooltipComponent && {
    //     formatter: function () {
    //       return renderToString(
    //           //@ts-ignore
    //           <TooltipComponent
    //               data={this}
    //               index={this.point.index}
    //               series={data}
    //           />
    //       );
    //     },
    //   }),
    // },
  };

  return (
    <div className={"w-full h-full"}>
      <Chart
        options={chartOptions}
        ref={chartRef}
        // options={chartOptions}
        // ref={chartRef}
      >
        <Title>{title}</Title>
        {/*<YAxis {...yAxis} />*/}
        {/*<XAxis {...xAxis} />*/}
        {series &&
          series.length > 0 &&
          series.map((item, index) => {
            // Spread, don't pass props one by one: `item` is a discriminated
            // union, so pulling `type` out on its own re-widens it and stops
            // matching any single member. Also carries the key React wants.
            return <Series key={index} {...item} />;
          })}
      </Chart>
    </div>
  );
}
